import axios from "../axiosInstance";
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import { errorMessage } from "../hooks/UserLogs";

export default function DetailsInvoiceAgent() {
    const { id } = useParams();
    const [invoice, setInvoice] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [errMsg,setErrMsg]=useState("Une erreure s'est produite!!");
    const [showError, setShowError] = useState(false);
    const bUrl = process.env.REACT_APP_B_URL;
    
    const navigate = useNavigate();

    const axiosInstance = axios.create({
                                withCredentials: true,
                              })

    const getInvoiceWalletDetails = async () => {

        const response = await axiosInstance.get(bUrl + "/invoice-wallet-agent/find-by-id?id=" + id).catch((err) => {

            if (err?.response?.status == 401 || err?.response?.status == 403) {
                setErrMsg("Vous n'étes pas autorisé à faire cette opération")
                setShowError(true);
              }else{
                let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
                setErrMsg(msg);
                setShowError(true);
              }
              console.error(err);

        });

        if (response) {
            
            if (response?.data?.isError) {
                const msg = errorMessage(response?.data?.code)
                setErrMsg(msg);
                setShowError(true);
              }else{
                setInvoice(response.data.body);
                console.log(response.data.body)
              }
        }
    }
    useEffect(() => {
        if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
            //console.log("----------GO GO GO ------------")
            navigate('/backoffice/login');
          }
        getInvoiceWalletDetails();
    }, [])
    return (
        <>
            <div className="">
                <Sidebar />
                <section className="home ">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">

                            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                                <div><p className='fw-bold'>Transactions&gt;Dépot&gt;Détails</p></div>
                                <div><Topbar /></div>
                            </div>
                            <div className="table-content mt-2 p-3">
                                <div className="d-flex justify-content-center text">
                                    <div className='col-md-3 bg-primary'>
                                    </div>
                                    {invoice?.agent?
                                        <div className='col-md-6 p-3'>

                                            <p className='fw-bold'>Agent</p>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Prénom:</div>
                                                <div className='col-3 fw-bold'>{invoice.agent.firstName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Deuxiéme nom</div>
                                                <div className='col-3 fw-bold'>{invoice.agent.middleName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Nom</div>
                                                <div className='col-3 fw-bold'>{invoice.agent.lastName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Téléphone:</div>
                                                <div className='col-3 fw-bold'>{invoice.agent.phone}</div>
                                            </div>
                                            <p className='fw-bold'>Marchand</p>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Prénom:</div>
                                                <div className='col-3 fw-bold'>{invoice.customerWallet.firstName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Deuxiéme nom</div>
                                                <div className='col-3 fw-bold'>{invoice.customerWallet.middleName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Nom</div>
                                                <div className='col-3 fw-bold'>{invoice.customerWallet.lastName}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Téléphone:</div>
                                                <div className='col-3 fw-bold'>{invoice.customerWallet.phone}</div>
                                            </div>
                                            <p className='fw-bold'>Transaction</p>

                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Code:</div>
                                                <div className='col-3 fw-bold'>{invoice.invoiceCode}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Frais:</div>
                                                <div className='col-3 fw-bold'>{invoice.amountToPaid - invoice.amountToSend}</div>
                                            </div>
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Status:</div>
                                                <div className='col-3 fw-bold'><sapan className="p-2" style={{ background: "rgb(0,255,0,.3)" }}>{invoice.invoiceStatus == 'P' ? 'Payée' : 'Echec'}</sapan></div>
                                            </div>
                                            {invoice.paymentModeObj != null ?
                                                <>
                                                    <div className='row mb-2 row-details'>
                                                        <div className='col-3'>Mode Paiement:</div>
                                                        <div className='col-3 fw-bold'>{invoice.paymentModeObj.name}</div>
                                                    </div>
                                                </>
                                                : ""}
                                            <div className='row mb-2 row-details'>
                                                <div className='col-3'>Total à payer:</div>
                                                <div className='col-3 fw-bold'>{invoice.amountToPaid}</div>
                                            </div>

                                        </div>
                                        : ""}
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}
